import { zeusApiV1 } from 'src/store/api';

type GetSyncArgs = { subsidiary: string };

export type IntegrationParamOption = {
  id: string;
  label: string;
  value: string;
};

const extendedApi = zeusApiV1.injectEndpoints({
  endpoints: build => ({
    runSync: build.mutation<any, GetSyncArgs>({
      query: ({ subsidiary }) => ({
        url: '/hercules/v1/integration/run',
        params: { subsidiary },
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { useRunSyncMutation } = extendedApi;
